export default [{
  path: '/stage/packageBuy',
  name: 'stage-packageBuy',
  title: '套餐购买',
  component: () => import('@/views/stage/template/packageBuy/index')
}];
